import type { Landmark } from '../../../data/types';
import type { MeshBuilder, VertexStyle } from '../../mesh/meshBuilder';
import { beamSolid, boxSolid } from '../solids';
import { dominantAxis, meshFrameOf, planBounds, planFrameOf } from './planFrame';

const WATER_BLOCKHOUSES = new Set([
  'landmark-blokhuis-boom-west',
  'landmark-blokhuis-boom-east',
]);

/** Timber foundations below the existing waterborne blocks. Submerged pile depth is estimated. */
export function buildBoomFoundation(builder: MeshBuilder, landmark: Landmark, wood: VertexStyle): void {
  if (!WATER_BLOCKHOUSES.has(landmark.id)) return;
  const plan = planFrameOf(landmark.footprint, dominantAxis(landmark.footprint, landmark.heading));
  const frame = meshFrameOf(plan);
  const { u0, u1, v0, v1 } = planBounds(plan);
  const us = [u0 + 0.3, (u0 + u1) / 2, u1 - 0.3];
  const vs = [v0 + 0.3, v1 - 0.3];
  for (const u of us) {
    for (const v of vs) beamSolid(builder, wood, frame, [u, -2.5, -v], [u, -0.25, -v], 0.2);
    beamSolid(builder, wood, frame, [u, -0.35, -v0 - 0.25], [u, -0.35, -v1 + 0.25], 0.18);
  }
  for (const v of vs) {
    for (let i = 1; i < us.length; i++) {
      beamSolid(builder, wood, frame, [us[i - 1]!, -1.6, -v], [us[i]!, -0.55, -v], 0.12);
    }
  }
  boxSolid(builder, wood, frame, [u0 - 0.3, -0.2, -v1 - 0.3], [u1 + 0.3, 0, -v0 + 0.3], { top: true, bottom: true });
}
